import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Dna, Sparkles } from "lucide-react";

interface WritingStylePromptDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreate: () => void;
  onSkip: () => void;
}

export function WritingStylePromptDialog({
  open,
  onOpenChange,
  onCreate,
  onSkip,
}: WritingStylePromptDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[90vw] sm:max-w-md">
        <DialogHeader className="text-center space-y-2">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
            <Dna className="h-6 w-6 text-primary" />
          </div>
          <DialogTitle>Set a Writing Style?</DialogTitle>
          <DialogDescription>
            Add a Writing Style to get more consistent, on-brand results.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 pt-2">
          <Button onClick={onCreate} className="w-full">
            <Sparkles className="h-4 w-4 mr-2" />
            Create Writing Style
          </Button>
          <Button variant="ghost" onClick={onSkip} className="w-full">
            Not now
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
